<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs
        main-link="welcome"
        :main="$t('dashboardVue.dashboard')"
        :title="$t('newInfoRequest.yeniInfromasiyaSorusu')"
      />

      <h4 class="mb-3">
        <span v-if="requestType==='RFI'">{{ $t('newInfoRequest.yeniInfromasiyaSorusu') }}</span>
        <span v-if="requestType==='LGI'">{{ $t('newInfoRequest.logistikInfromasiyaSorusu') }}</span>
        <span v-if="requestType==='CSI'">{{ $t('newInfoRequest.gmrkInfromasiyaSorusu') }}</span>
        <span v-if="requestType==='WHI'">{{ $t('newInfoRequest.anbarInfromasiyaSorusu') }}</span>
      </h4>


      <input
        id="fileInput"
        ref="file"
        type="file"
        style="display: none"
        @change="setPhoto"
      >

      <form @submit.prevent="createRequest">
        <div
          v-if="['LGI','WHI','CSI'].indexOf(requestType)<0"
          class="card shadow"
        >
          <div class="card-body">
            <h4>
              {{ $t('newInfoRequest.sorunuzHansSahyAiddir') }}
            </h4>

            <p>
              {{ $t('newAUCRequest.sorununYaradarknFaliyytSahsiniSemkMtlqdirSizMaximu') }}
            </p>

            <div class="mt-3">
              <button
                v-b-modal.modal-sector-selection
                type="button"
                class="btn btn-sm btn-light-primary"
              >
                {{ $t('companyProfile.faliyytSahsiniSein') }}
              </button>
            </div>

            <hr v-if="requestSectors.length>0">
            <SelectedSectorView
              :sectors="requestSectors"
              :parent-id="0"
            />
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <div class="mb-3">
              <label>{{ $t('newInfoRequest.soruBal') }}</label>
              <b-form-input
                id="new_request_title"
                v-model="requestTitle"
                type="text"
                required
              />
            </div>


            <div class="mb-3">
              <label>{{ $t('newInfoRequest.soruMtni') }}</label>
              <b-form-textarea
                id="new_request_description"
                v-model="requestDescription"
                required
                rows="4"
              />
              <span
                v-if="requestDescription.length<20"
                class="text-secondary"
              >{{ $t('newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr') }}</span>
            </div>

            <div
              v-if="requestType === 'RFI'"
              class="mb-4"
            >
              <label>{{ $t('newInfoRequest.soruNticsind') }}</label>
              <div class="form-check">
                <input
                  id="requestSubTypeInfo"
                  v-model="requestSubType"
                  class="form-check-input"
                  type="radio"
                  name="requestSubType"
                  value="info"
                >
                <label
                  class="form-check-label"
                  for="requestSubTypeInfo"
                >
                  <span>{{ $t('newInfoRequest.mlumatAlmaqIstyirm') }}</span>
                </label>
              </div>
              <div class="form-check">
                <input
                  id="requestSubTypePurchase"
                  v-model="requestSubType"
                  class="form-check-input"
                  type="radio"
                  name="requestSubType"
                  value="purchase"
                >
                <label
                  class="form-check-label"
                  for="requestSubTypePurchase"
                >
                  <span>{{ $t('newInfoRequest.mhsulVYaXidmtSatnAlmaqIstyirm') }}</span>
                </label>
              </div>
            </div>


            <div class="mb-3 w-50">
              <label>{{ $t('newInfoRequest.sorununBitmTarixi') }}</label>
              <DatePicker
                v-model="requestDeadline"
                mode="dateTime"
                is24hr
                :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                :minute-increment="15"
                :min-date="minDeadline"
                :is-required="true"
                :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
              >
                <template #default="{ inputValue, inputEvents }">
                  <input
                    type="text"
                    class="form-control "
                    :value="inputValue"
                    placeholder=""
                    required
                    v-on="inputEvents"
                  >
                </template>
              </DatePicker>
            </div>



            <div class="mb-3">
              <label>{{ $t('newInfoRequest.lavFayllar') }}</label> <br>
              <p>{{ $t('newInfoRequest.sorunuzlaBalLavFayllarYklyBilrsiniz') }}</p>

              <div class="d-flex">
                <button
                  type="button"
                  class="btn btn-sm btn-light-primary"
                  @click.prevent="selectPhoto(-1)"
                >
                  {{ $t('newInfoRequest.yeniFaylYkl') }}
                </button>
                <div
                  v-if="uploadProgress >0 && uploadProgress <100"
                  class="progress"
                >
                  <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{width: `${uploadProgress}%`}"
                  />
                </div>
              </div>
              <div
                v-if="requestFiles.length>0"
                class="w-50 mt-3"
              >
                <div
                  v-for="(f,i) in requestFiles"
                  :key="f.path"
                  class="requestFile py-1"
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <a
                        :href="getPhoto(f.path,'')"
                        class="text-secondary"
                      >
                        <i class="fa fa-paperclip mr-1" />
                        {{ f.path.split('/').pop() }}
                      </a>
                    </div>

                    <div
                      class="d-flex align-items-center cursor-pointer"
                      href="#"
                      @click="deleteFile(i)"
                    >
                      <feather
                        type="x"
                        size="16"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class=" mb-2 ">
              <div class="d-flex align-items-center">
                <div class="checkbox checkbox-success mt-3">
                  <b-form-checkbox
                    v-model="requestIsPrivate"
                    value="1"
                    :disabled="onlyVendors>0"
                  >
                    <div>
                      {{ $t('newAUCRequest.mllifiGizlt') }} <br> <span
                        v-if="requestIsPrivate"
                        class="text-danger"
                      >
                        {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}
                      </span>
                      <span
                        v-else
                        class="text-success"
                      >
                        {{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}
                      </span>
                    </div>
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div>
              <div class="d-flex align-items-center">
                <div class="checkbox checkbox-success">
                  <b-form-checkbox
                    v-model="requestIsPersonalAllowed"
                    value="1"
                  >
                    {{ $t('newAUCRequest.frdiVensizXslrSorunuCavablayaBilsin') }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <div
              v-if="['LGI','CSI','WHI'].indexOf(requestType)>-1 && profile==='PROCUREMENT'"
            >
              <div class="d-flex align-items-center">
                <div class="checkbox checkbox-success">
                  <b-form-checkbox
                    v-model="onlyVendors"
                    value="1"
                    :disabled="!vendorManagementAvailable || requestIsPrivate>0 "
                  >
                    {{ $t('newInfoRequest.ancaqTsdiqlnmiTdarklrimCavablayaBilsin') }}
                    <br>
                    <span
                      v-if="!vendorManagementAvailable"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.buFunksiyanIstifadEtmkN') }} <strong>{{ $t('newInfoRequest.vendorManagement') }}</strong> {{ $t('newInfoRequest.lavsiniAktivldirmlisniz') }}

                      <router-link :to="{name: 'addOnPage'}">{{ $t('newInfoRequest.aktivldir') }}</router-link>
                    </span>
                    <span
                      v-if="requestIsPrivate>0"
                      class="text-danger"
                    >
                      {{ $t('newInfoRequest.gizliSorularNBuFunskiyaAktivDeyil') }}
                    </span>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>


        <button class="btn btn-primary">
          <span>{{ $t('newInfoRequest.sorunuYarat') }}</span>
        </button>
      </form>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header-close="false"
      class="theme-modal"
      :busy="false"
      :hide-footer="true"
    >
      <sector_selection_modal
        :max-selection="5"
        :parent-sector="null"
        :selected="requestSectors"
        @done="sectorSelected($event)"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  createRequest, getVendorManagementStatus, upload
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Datepicker from 'vuejs-datepicker';
import {deliveryTypes, getPhoto, loadTypes} from "@/repositories/Utils";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import dayjs from "dayjs";

export default {
  components: {
    SelectedSectorView,
    Sector_path,
    Sector_selection_modal,
    Multiselect, Datepicker
  },
  data() {
    return {
      mediaBase: mediaBase,
      requestType: '',
      requestSubType: '',
      faq: [],
      requestTitle: '',
      requestDescription: '',
      requestIsPrivate: 0,
      requestIsPersonalAllowed: 0,
      onlyVerified: 0,
      onlyVendors: 0,
      requestDeadline: '',
      requestFiles: [],
      requestSectors: [],
      sectors: [],
      uploadProgress: 0,
      products: [],
      photoIndex: 0,
      rfqTerms: 0,
      orderExtras: {
        pickUpCountry: '',
        pickUpCity: '',
        pickUpAddress: '',
        dropOffCountry: '',
        dropOffCity: '',
        dropOffAddress: '',
        deadline: '',
        notes: '',
        incoterms: '',
        types: [],
        loadSize: '',
        loadUnit: '',
        multiSelect: 0,
        ownVariant: 0
      },
      format: "dd MMM yyyy",
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      pollAnswerList: [],

      vendorManagementAvailable: false
    };
  },
  watch: {

    "$route"() {
      this.requestType = this.$route.query.type;
    },
    onlyVerified(newVal) {
      if (newVal) {
        this.$swal({
          //TODO LANGUAGE

          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.onlyVerifiedModalText"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal) {
        // this.$swal({
        //   //TODO LANGUAGE
        //
        //   title: this.$t("generalModal.warningTitle"),
        //   text: this.$t("newAUCRequest.onlyVendorModalText"),
        //   icon: 'warning'
        // })
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),

    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    }

  },
  mounted() {

    this.requestType = this.$route.query['type'] || '';

    if (this.requestType === '') {
      this.$router.push({name: 'welcome'});
    }

    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })

  },
  methods: {
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },

    sectorSelected(sectors) {
      this.requestSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    createRequest() {
      let sectors = this.requestSectors.map(function (elem) {
        return elem.id;
      }).join(",");
      switch (this.requestType) {
        case "LGI":
          sectors = 13;
          break;
        case "CSI":
          sectors = 14;
          break;
        case "WHI":
          sectors = 12;
          break;
      }

      let extras = {};

      if (this.requestType !== 'RFI') {
        this.requestSubType = this.requestType;
      }

      if (this.requestTitle !== '' && this.requestDescription.length >= 20 && (sectors + "").length > 0) {

        createRequest(
            this.token,
            this.requestType, this.requestSubType,
            sectors,
            this.requestTitle, this.requestFiles, this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate, this.requestIsPersonalAllowed,
            this.onlyVerified, this.onlyVendors,
            JSON.stringify(extras),
            this.products, this.pollAnswerList
        ).then(data => {

          if (data.code === 200) {

            this.$router.replace('/dashboard/request/' + data.id);

          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })

      } else if (sectors.length < 1) {
        this.$swal({
          //TODO LANGUAGE
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("generalModal.noWorkingSectorWarning"),
          icon: 'error'
        })
      } else if (this.requestDescription.length < 20) {
        this.$swal({
          //TODO LANGUAGE
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.soruSpesifikasiyasNAz20SimvoldanIbartOlmaldr"),
          icon: 'error'
        })
      } else {
        this.$swal({
          //TODO LANGUAGE
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.butunBolmeleri"),
          icon: 'error'
        })
      }

    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    selectPhoto(index) {
      this.photoIndex = index;
      window.document.getElementById('fileInput').click();
    },

    deleteFile(index) {
      //TODO LANGUAGE
      if (confirm(this.$t("general.fileDltConfirm"))) {
        this.requestFiles.splice(index, 1);
      }
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'requestPhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                  this.requestFiles.push({
                    id: 0,
                    path: response.data.path,
                    type: "request"
                  });
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: "Could not upload the file! " + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: "Photo upload is not supported on your browser",
          icon: 'error'
        })
      }
    },

  }

}
</script>
